import React from 'react';
import Toast from './Toast';
import { render } from '../ApiContainer';

let hideTimer = null;

class ToastContainer extends React.Component {
  static getInstance() {
    return render(ToastContainer);
  }

  static getResetState(state) {
    const result = {};
    Object.keys(state).forEach((key) => {
      result[key] = undefined;
    });

    return result;
  }

  state = {};

  show(props, time = 1000) {
    const { onShowEnd, ...rest } = props;
    const resetState = ToastContainer.getResetState(this.state);
    this.setState({
      ...resetState,
      ...rest,
      visible: true,
      onShowEnd: () => {
        if (time >= 0) {
          hideTimer = setTimeout(() => {
            this.hide();
          }, time);
        }
        onShowEnd && onShowEnd();
      }
    });
  }

  hide(props) {
    clearTimeout(hideTimer);
    hideTimer = null;

    this.setState({
      ...props,
      visible: false
    });
  }

  loading(props, time) {
    this.show({ ...props, type: 'loading' }, time);
  }

  success(props, time) {
    this.show({ ...props, type: 'success' }, time);
  }

  failure(props, time) {
    this.show({ ...props, type: 'failure' }, time);
  }

  render() {
    return (<Toast {...this.state} />);
  }
}

export function show(props, time) {
  return ToastContainer.getInstance().then((instance) => {
    instance.show(props, time);
  });
}

export function hide(props) {
  return ToastContainer.getInstance().then((instance) => {
    instance.hide(props);
  });
}

export function loading(props) {
  return ToastContainer.getInstance().then((instance) => {
    instance.loading(props);
  });
}

export function success(props) {
  return ToastContainer.getInstance().then((instance) => {
    instance.success(props);
  });
}

export function failure(props) {
  return ToastContainer.getInstance().then((instance) => {
    instance.failure(props);
  });
}
